const AiOutlined = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.92863 14.2904V10.957M2.92863 4.29036V0.957031M1.26196 2.6237H4.5953M1.26196 12.6237H4.5953M8.5953 1.6237L7.43918 4.62961C7.25117 5.11843 7.15717 5.36284 7.01098 5.56842C6.88142 5.75063 6.72223 5.90982 6.54002 6.03938C6.33443 6.18557 6.09002 6.27957 5.6012 6.46758L2.5953 7.6237L5.60121 8.77982C6.09002 8.96782 6.33443 9.06183 6.54002 9.20801C6.72223 9.33757 6.88142 9.49677 7.01098 9.67897C7.15717 9.88456 7.25117 10.129 7.43918 10.6178L8.5953 13.6237L9.75142 10.6178C9.93942 10.129 10.0334 9.88456 10.1796 9.67897C10.3092 9.49677 10.4684 9.33757 10.6506 9.20801C10.8562 9.06183 11.1006 8.96782 11.5894 8.77982L14.5953 7.6237L11.5894 6.46758C11.1006 6.27957 10.8562 6.18557 10.6506 6.03938C10.4684 5.90982 10.3092 5.75063 10.1796 5.56842C10.0334 5.36284 9.93942 5.11843 9.75141 4.62961L8.5953 1.6237Z"
      stroke="#535862"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default AiOutlined;
